(() => {
  console.log("script loaded")
  const getMapForSection = (root) => {
    const section = root?.closest?.('.product__info-container');
    if (!section) return null;

    const script = section.querySelector('script[id^="VariantDisableMap-"]');
    if (!script) return null;
    try {
      return JSON.parse(script.textContent);
    } catch (e) {
      console.warn('[variant-disable] invalid JSON map', e);
      return null;
    }
  };

  const getVariantPickerRoot = (el) => {
    return el?.closest?.('variant-selects') || document.querySelector('variant-selects');
  };

  const readSelectedOptions = (pickerRoot) => {
    const opts = [];

    // selects
    pickerRoot.querySelectorAll('select').forEach((sel) => opts.push(sel.value));

    // radios (fieldset)
    const fieldsets = pickerRoot.querySelectorAll('fieldset');
    fieldsets.forEach((fs) => {
      const checked = fs.querySelector('input[type="radio"]:checked');
      if (checked) opts.push(checked.value);
    });

    return opts;
  };

  const findVariantByOptions = (map, selectedOptions) => {
    const [o1, o2, o3] = selectedOptions;
    return map.variants.find((v) => {
      if (o1 && v.option1 !== o1) return false;
      if (o2 && v.option2 !== o2) return false;
      if (o3 && v.option3 !== o3) return false;
      return true;
    }) || null;
  };

  const isCandidate = (v, selectedOptions, optionIndex, optionValue) => {
    // selectedOptions: [opt1,opt2,opt3]
    // optionIndex is 0-based (0=color, 1=size)
    // optionValue is the value we are testing for that index
    for (let i = 0; i < 3; i++) {
      const sel = selectedOptions[i];
      if (!sel) continue;

      const vv = i === 0 ? v.option1 : i === 1 ? v.option2 : v.option3;

      // for the tested option index, compare against optionValue instead of current selection
      if (i === optionIndex) {
        if (vv !== optionValue) return false;
      } else {
        if (vv !== sel) return false;
      }
    }
    return true;
  };

  const variantIsSelectable = (v) => !v.disabled;

  const setChoice = (pickerRoot, optionIndex, value) => {
    // Try selects first
    const selects = Array.from(pickerRoot.querySelectorAll('select'));
    if (selects.length) {
      const sel = selects[optionIndex];
      if (sel) {
        sel.value = value;
        sel.dispatchEvent(new Event('change', { bubbles: true }));
        return true;
      }
    }

    // Then radios
    const fieldsets = Array.from(pickerRoot.querySelectorAll('fieldset'));
    if (fieldsets.length) {
      const fs = fieldsets[optionIndex];
      if (!fs) return false;
      const input = fs.querySelector(`input[type="radio"][value="${CSS.escape(value)}"]`);
      if (input) {
        input.click(); // Dawn listens to change/click via its components
        return true;
      }
    }

    return false;
  };

  const hideOrDisableOptionValue = (pickerRoot, optionIndex, value, shouldHide) => {
    // dropdown option
    const selects = Array.from(pickerRoot.querySelectorAll('select'));
    if (selects.length) {
      const sel = selects[optionIndex];
      if (!sel) return;
      const opt = Array.from(sel.options).find((o) => o.value === value);
      if (!opt) return;

      opt.disabled = !!shouldHide;
      // keep it visible but disabled in dropdown (better UX)
      return;
    }

    // radios: hide the whole label if possible
    const fieldsets = Array.from(pickerRoot.querySelectorAll('fieldset'));
    const fs = fieldsets[optionIndex];
    if (!fs) return;

    const input = fs.querySelector(`input[type="radio"][value="${CSS.escape(value)}"]`);
    if (!input) return;

    const label = input.closest('label');
    if (label) label.style.display = shouldHide ? 'none' : '';
    input.disabled = !!shouldHide;
  };

  function refreshUI(pickerRoot) {
    console.log(pickerRoot, "pickerRoot", !pickerRoot);
    if (!pickerRoot) return;
    
    const map = getMapForSection(pickerRoot);
    if (!map?.variants?.length) return;
    if (map?.variants_count > 250) return;
    
    const variants = map.variants;
    const variantIsSelectable = (v) => !v.disabled;

    const getCurrentSelection = () => {
        const selected = [null, null, null];

        // Dropdowns
        const selects = pickerRoot.querySelectorAll("select");
        if (selects.length) {
        selects.forEach((sel, i) => (selected[i] = sel.value || null));
        return selected;
        }

        // Radios/buttons
        const fieldsets = pickerRoot.querySelectorAll("fieldset");
        fieldsets.forEach((fs, i) => {
        const checked = fs.querySelector('input[type="radio"]:checked');
        selected[i] = checked ? checked.value : null;
        });

        return selected;
    };

    const getDomOptionValues = () => {
        const optionValues = [[], [], []];

        const selects = pickerRoot.querySelectorAll("select");
        if (selects.length) {
        selects.forEach((sel, i) => {
            optionValues[i] = Array.from(sel.options).map(o => o.value).filter(Boolean);
        });
        return optionValues;
        }

        const fieldsets = pickerRoot.querySelectorAll("fieldset");
        fieldsets.forEach((fs, i) => {
        optionValues[i] = Array.from(fs.querySelectorAll('input[type="radio"]')).map(i => i.value);
        });

        return optionValues;
    };

    const hideOrDisable = (optionIndex, value, hide) => {
        const selects = pickerRoot.querySelectorAll("select");
        if (selects.length) {
        const sel = selects[optionIndex];
        if (!sel) return;
        const opt = Array.from(sel.options).find((o) => o.value === value);
        if (!opt) return;
        opt.disabled = !!hide;
        opt.hidden = false; // keep visible but disabled
        return;
        }

        const fieldsets = pickerRoot.querySelectorAll("fieldset");
        const fs = fieldsets[optionIndex];
        if (!fs) return;

        const input = fs.querySelector(`input[type="radio"][value="${CSS.escape(value)}"]`);
        if (!input) return;

        const label = fs.querySelector(`label[for="${CSS.escape(input.id)}"]`) || input.closest("label");
        if (label) label.style.display = hide ? "none" : "";
        if (input.classList.contains('disabled')){
          input.classList.remove('disabled')
        }
        input.disabled = !!hide;
    };

    const setChoice = (optionIndex, value) => {
        const selects = pickerRoot.querySelectorAll("select");
        if (selects.length) {
        const sel = selects[optionIndex];
        if (!sel) return false;
        if (sel.value === value) return false;
        sel.value = value;
        sel.dispatchEvent(new Event("change", { bubbles: true }));
        return true;
        }

        const fieldsets = pickerRoot.querySelectorAll("fieldset");
        const fs = fieldsets[optionIndex];
        if (!fs) return false;

        const input = fs.querySelector(`input[type="radio"][value="${CSS.escape(value)}"]`);
        if (!input) return false;

        if (input.checked) return false;
        input.click();
        return true;
    };

    const optionValues = getDomOptionValues();
    let [c1, c2, c3] = getCurrentSelection();
    let changed = false;

    // ---------- OPTION 1 (Color): exists any selectable variant with option1
    const allowed1 = new Set(
        variants.filter(variantIsSelectable).map(v => v.option1).filter(Boolean)
    );
    optionValues[0]?.forEach(v => hideOrDisable(0, v, !allowed1.has(v)));
    
    if (!c1 || !allowed1.has(c1)) {
        const first = optionValues[0]?.find(v => allowed1.has(v));
        if (first) {
        changed = setChoice(0, first) || changed;
        c1 = first;
        }
    }

    // ---------- OPTION 2 (Size): exists any selectable variant with (option1 + option2)
    const allowed2 = new Set(
        variants
        .filter(v => variantIsSelectable(v) && v.option1 === c1)
        .map(v => v.option2)
        .filter(Boolean)
    );
    optionValues[1]?.forEach(v => hideOrDisable(1, v, !allowed2.has(v)));

    if (!c2 || !allowed2.has(c2)) {
        const first = optionValues[1]?.find(v => allowed2.has(v));
        if (first) {
        changed = setChoice(1, first) || changed;
        c2 = first;
        }
    }

    // ---------- OPTION 3 (Yes/No): exists selectable variant with (option1 + option2 + option3)
    // Here we filter by option1+option2 and allow only option3 values that exist
    const allowed3 = new Set(
        variants
        .filter(v => variantIsSelectable(v) && v.option1 === c1 && v.option2 === c2)
        .map(v => v.option3)
        .filter(Boolean)
    );
    optionValues[2]?.forEach(v => hideOrDisable(2, v, !allowed3.has(v)));

    if (optionValues[2]?.length) {
        if (!c3 || !allowed3.has(c3)) {
        const first = optionValues[2]?.find(v => allowed3.has(v));
        if (first) {
            changed = setChoice(2, first) || changed;
            c3 = first;
        }
        }
    }
  }


  document.addEventListener('change', (e) => {
    const pickerRoot = getVariantPickerRoot(e.target);
    if (pickerRoot) refreshUI(pickerRoot);
  });

  const boot = () => {
    const pickerRoot = document.querySelector('variant-selects');
    if (pickerRoot) refreshUI(pickerRoot);
  };

  document.addEventListener('DOMContentLoaded', boot);

  const mo = new MutationObserver(() => boot());
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
